// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
const { TYPES: modelTypes } = require('shared/model-types')
// Client V2 common imports
const AppFooter = require('client-v2/common/containers/app-footer/component-smart')
const Icon = require('client-v2/common/containers/icons/component')
const useInfiniteScroll = require('client-v2/common/hooks/infinite-scroll')
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const SeriesFeedArticle = require('./article')

const bem = BemEntity('SeriesFeed')

const LOAD_MORE_THRESHOLD = 1000 // px

function SeriesFeed({
  // Values
  className,
  isMoreAvailable,
  isMoreLoading,
  items,
  title,
  // Callbacks
  onArticleBookmark,
  onArticleContentNavigate,
  onArticleDomainNavigate,
  onArticleEmbedDisclose,
  onArticleMoreActions,
  onArticleRate,
  onArticleSeen,
  onArticleShare,
  onLoadMore
}) {
  const blockRef = React.useRef()
  useInfiniteScroll({
    disabled: !isMoreAvailable,
    scrollableRef: blockRef,
    loadMoreThreshold: LOAD_MORE_THRESHOLD,
    onLoadMore
  })
  return (
    tag('section', {
      ref: blockRef,
      className: classNames(
        className,
        bem.block()
      ),
      role: 'main'
    },
      tag('div', {
        className: bem.element('header')
      },
        title
      ),
      items.map(({ type, id, article, meta, pageContext }) => {
        if (type !== modelTypes.ARTICLE) {
          return null
        }
        return (
          tag(SeriesFeedArticle, {
            key: `${type}:${id}`,
            // Values
            className: bem.element('item'),
            article,
            meta,
            pageContext,
            // Callbacks
            onArticleBookmark,
            onArticleContentNavigate,
            onArticleDomainNavigate,
            onArticleEmbedDisclose,
            onArticleMoreActions,
            onArticleRate,
            onArticleSeen,
            onArticleShare
          })
        )
      }),
      isMoreLoading && (
        tag(Icon, {
          className: bem.element('loading'),
          id: 'spinner'
        })
      ),
      (!isMoreAvailable && !isMoreLoading) && (
        tag(AppFooter, {
          className: bem.element('footer')
        })
      )
    )
  )
}

module.exports = SeriesFeed
